import Gamepad, { Event } from "core/gamepad";
export default async function GamepadTest(element) {
  element.setStateIcon("busy");
  element.setStateText("Bitte eine Taste drücken ...");
  return new Promise((res, rej) => {
    Gamepad.on(Event.Connect, connected);
    function connected(gamepad) {
      Gamepad.off(Event.Connect, connected);
      element.setStateIcon("ok");
      element.setStateText(gamepad.id);
      res(true);
    }
  });
}